import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorHandlerService } from '../../services/shared/error-handler.service';
import { UserServiceService } from '../../services/user-service/user-service.service';

@Component({
  selector: 'app-view-nationality',
  templateUrl: './view-nationality.component.html',
  styleUrls: ['./view-nationality.component.css']
})
export class ViewNationalityComponent implements OnInit {
  nationalities: any;

  constructor(
    private userService: UserServiceService,
    private errorHandlerService: ErrorHandlerService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getNationalities();
  }

  getNationalities() {
    this.userService.getNationalities().subscribe(
      (res: any) => {
        this.nationalities = res;
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  editNationality(id) {
    return this.router.navigate(["/pages/settings/nationality/edit", id]);
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/view-nationality/view-nationality.component.ts